import api from "../../../../services/api";
import { getExtratoSolicitacaoById } from "../../../../services/ExtractService";
import type { ExtratoSolicitacaoDetalheResponse } from "../../../../services/ExtractService";
import {
  EXTRACT_SINDICATO_FORCE_MOCK,
  mockConfirmarExtratoSindicato,
  mockExtratoSindicatoDetalhe,
  mockExtratoSindicatoListagem,
  type ConfirmacaoExtratoSindicatoResult,
} from "./extractSindicatoMock";

export type ConfirmacaoExtratoSindicatoPayload = {
  validado: boolean;
  observacaoSindicato?: string;
};

const ENDPOINT_NAO_DISPONIVEL = (status?: number) =>
  status === 404 || status === 501 || status === 405;

export const fetchExtratoSindicatoDetalhe = async (
  solicitacaoAvaliacaoId: number | string,
): Promise<ExtratoSolicitacaoDetalheResponse> => {
  if (EXTRACT_SINDICATO_FORCE_MOCK) {
    return mockExtratoSindicatoDetalhe(solicitacaoAvaliacaoId);
  }

  const detalhe = await getExtratoSolicitacaoById(solicitacaoAvaliacaoId);
  if (!detalhe) {
    throw new Error("Extrato não encontrado.");
  }

  return detalhe;
};

export const fetchExtratoSindicatoListagem = async () => {
  if (EXTRACT_SINDICATO_FORCE_MOCK) {
    return mockExtratoSindicatoListagem();
  }

  return null;
};

// Endpoint: POST /api/extratos-avaliacoes/solicitacoes/{solicitacaoAvaliacaoId}/validacao
export const confirmarExtratoSindicato = async (
  solicitacaoAvaliacaoId: number | string,
  payload: ConfirmacaoExtratoSindicatoPayload,
): Promise<ConfirmacaoExtratoSindicatoResult> => {
  if (EXTRACT_SINDICATO_FORCE_MOCK) {
    return mockConfirmarExtratoSindicato(payload.validado);
  }

  try {
    const response = await api.post(
      `/api/extratos-avaliacoes/solicitacoes/${solicitacaoAvaliacaoId}/validacao`,
      payload,
    );

    if (response?.status === 200 || response?.status === 204) {
      return {
        sucesso: true,
        mock: false,
        mensagem: payload.validado
          ? "Extrato confirmado com sucesso."
          : "Registramos que você não está de acordo com os valores do extrato.",
        situacao: payload.validado ? "Extrato validado" : undefined,
      };
    }

    return {
      sucesso: false,
      mock: false,
      mensagem: "Não foi possível confirmar o extrato.",
    };
  } catch (error: unknown) {
    const status = (error as { response?: { status?: number } })?.response
      ?.status;

    if (
      ENDPOINT_NAO_DISPONIVEL(status) ||
      process.env.NODE_ENV === "development"
    ) {
      console.warn(
        "[Extrato Sindicato] Endpoint de confirmação indisponível — usando mock.",
        status,
      );
      return mockConfirmarExtratoSindicato(payload.validado);
    }

    console.error("Erro ao confirmar extrato do sindicato:", error);
    return {
      sucesso: false,
      mock: false,
      mensagem: "Erro ao confirmar o extrato. Tente novamente.",
    };
  }
};
